import { cleanAndTruncateText } from '@/modules/stringUtils';
import PageSEO from '@/shared/PageSEO/PageSEO';
import PublicPage from '@/shared/PublicPage/PublicPage';
import ThemeDetail from '@/shared/ThemeDetail/ThemeDetail';

export default function PublicActivity({ activity, activityType }) {
  const seoTitle = activity.seoMetadata?.title ?? activity.englishName;
  const seoDescription =
    activity.seoMetadata?.description ?? activity.shortDescription
      ? cleanAndTruncateText(activity.shortDescription)
      : '';
  const ogImage = activity.theme?.thumb;

  return (
    <>
      <PageSEO
        title={seoTitle}
        description={seoDescription}
        ogImage={ogImage}
      />
      <PublicPage withFooter>
        <ThemeDetail
          serverSideTheme={activity.theme}
          serverSideActivity={activity}
          activityType={activityType}
        />
      </PublicPage>
    </>
  );
}
